import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=56085fbf&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalsMobileOverlay: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/modals/MobileOverlay.vue').default})
